/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class TimeRangeDirectiveController {

        public static $inject: string[] = [
            'DataUtils'
        ];

        public dataUtils            : any;

        public type                 : string;
        public startTime            : any;
        public startTimeChoices     : any[];
        public endTime              : any;
        public endTimeChoices       : any[];
        public blockSize            : string;
        public militaryTime         : boolean;
        public timeSegmentSeparator : string;
        public showEqChoice         : boolean = true;
        public onCancel             : any;
        public onClear              : any;
        public onApply              : any;
        public checkIsCancelDisabled: any;
        public checkIsClearDisabled : any;
        public checkIsApplyDisabled : any;

        public timeRangeBlockSizes  : any = {
            hour              : 1,
            'half-hour'       : 2,
            'quarter-hour'    : 4
        };

        constructor(
            public DataUtils : any
        ) {

            this.dataUtils = this.DataUtils.getInstance();

            this.blockSize = this.blockSize || 'hour';
            this.startTimeChoices = this.getTimeChoices();
            this.endTimeChoices   = this.getTimeChoices();

            this.parseStartEndTimes();
        }

        public parseStartEndTimes () : void {

            // The format we want and which we use as values for each of the time block options in the
            // SELECT, is military time:
            //
            // - hhmm or hh:mm, e.g. 0900 or 05:00, depending on the value of timeSegmentSeparator.
            //
            // For given startTime and endTimes, any or all of the following variations of that format
            // can be parsed:
            //
            // - hhmm with or without seconds (which are stripped out);
            // - hhmm with or without colons as separators between the time parts (which are stripped out);
            // - hhmm with or without AM and PM, and each of those can be any case, contain a preceeding space,
            //   or a trailing period in either or both parts of the meridian string, The inclusion of PM causes
            //   12 hours to get added to the military time value;
            // - Any combination of the above.
            //
            // Anything else won't be understood and will likely cause the time menu(s) to default to
            // their first option, either '0000' or 'Midnight'.  The parent controller is responsible for
            // converting ISO/UTC/time-zone-aware date/time strings into one of these parsable time strings.
            //
            var acceptedFormat = new RegExp('^(\\d{1,2})\:?(\\d{2})(?:\:?(\\d{2}))?(?: ?((?:[apAP]\.?))(?:[mM]\.?)?)?$');
            [ 'start', 'end' ].forEach( ( timeType: string ) => {
                if (acceptedFormat.test((<any>this)[timeType + 'Time'])) {
                    (<any>this)[timeType + 'Time'] = (<any>this)[timeType + 'Time'].replace(acceptedFormat,
                        ( match: string, hour: string, minute: string, second: string, meridian: string ) => {
                            return this.dataUtils.zeroPad(
                                parseInt(hour, 10) + (/[pP]/.test(meridian) ? 12 : 0)
                            ) + (this.timeSegmentSeparator !== undefined ? this.timeSegmentSeparator : '') + minute;
                        }
                    )
                }
            })
        }

        public getTimeChoices() : any[] {

            var that = this;

            var timeChoices : any[] = [ ];
            for (var i = 0; i < 24 * this.blockSizeValue; i++) {

                timeChoices.push(
                    { value: that.getTimeBlockValue (i), label: that.getTimeBlockLabel (i) }
                );
            }

            return timeChoices;
        }

        public getTimeBlockValue (n: number) : string {

            var blockSize : number = this.blockSizeValue;

            return this.dataUtils.zeroPad ( Math.floor(n / blockSize).toString() )
                       + (this.timeSegmentSeparator !== undefined ? this.timeSegmentSeparator : '')
                       + this.dataUtils.zeroPad ( ((n % blockSize) * (60 / blockSize)).toString() );
        }

        public get blockSizeValue () : number {
            return this.timeRangeBlockSizes[this.blockSize];
        }

        public getTimeBlockLabel (n: number) : string {

            if (this.militaryTime) {
                // Always show military time to the user without any separators.
                //
                return this.getTimeBlockValue(n).replace(new RegExp(this.timeSegmentSeparator), '');
            }

            var blockSize : number = this.blockSizeValue;

            return n === 0              ? 'Midnight' :
                   n === blockSize * 12 ? 'Noon' :
                       ( (Math.floor(n / blockSize) % 12) || 12 ) + ':'
                       + this.dataUtils.zeroPad ( ((n % blockSize) * (60 / blockSize)).toString() )
                       + (Math.floor(n / blockSize) >= 12 ? ' PM' : ' AM');
        }

        public cancel() : void {
            if (this.onCancel && angular.isFunction(this.onCancel)) {
                this.onCancel();
            }
        }

        public clear() : void {
            if (this.onClear && angular.isFunction(this.onClear)) {
                this.onClear();
            }
        }

        public apply() : void {
            if (this.onApply && angular.isFunction(this.onApply)) {
                this.onApply();
            }
        }

        public isCancelDisabled () : boolean {

            if (this.checkIsCancelDisabled && angular.isFunction(this.checkIsCancelDisabled)) {
                return this.checkIsCancelDisabled();
            }

            return false;
        }

        public isClearDisabled () : boolean {

            if (this.checkIsClearDisabled && angular.isFunction(this.checkIsClearDisabled)) {
                return this.checkIsClearDisabled();
            }

            return false;
        }

        public isApplyDisabled () : boolean {

            if (this.checkIsApplyDisabled && angular.isFunction(this.checkIsApplyDisabled)) {
                return this.checkIsApplyDisabled();
            }

            return false;
        }
    }

    getDealerwareWebComponentsModule().controller('TimeRangeDirectiveController', TimeRangeDirectiveController);

    export class TimeRangeDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'TimeRangeDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/time_range/time_range_directive.html';
        public scope            : Object    =   {
            type                    : '=',
            blockSize               : '=?',
            startTime               : '=?',
            endTime                 : '=?',
            militaryTime            : '=?',
            timeSegmentSeparator    : '@?',
            onCancel                : '&',
            onClear                 : '&?',
            onApply                 : '&',
            checkIsCancelDisabled   : '&?',
            checkIsClearDisabled    : '&?',
            checkIsApplyDisabled    : '&?'
        };
    }

    getDealerwareWebComponentsModule().directive('dealerwareTimeRange',
        () => new TimeRangeDirective()
    );
 }
